class ModalRegistry {
  constructor() {
    if (ModalRegistry.instance) {
      return ModalRegistry.instance;
    }
    this.modals = new Map();
    ModalRegistry.instance = this;
  }

  register(modalId, component) {
    if (this.modals.has(modalId)) {
      console.warn(`Modal with id ${modalId} is already registered`);
      return;
    }
    this.modals.set(modalId, component);
  }

  deregister(modalId) {
    if (!this.modals.has(modalId)) {
      console.warn(`Modal with id ${modalId} is not registered`);
      return;
    }
    this.modals.delete(modalId);
  }

  get(modalId) {
    if (!this.modals.has(modalId)) {
      console.warn(`Modal with id ${modalId} is not registered`);
      return null;
    }
    return this.modals.get(modalId);
  }

  getAll() {
    return Object.fromEntries(this.modals);
  }

  clear() {
    this.modals.clear();
  }
}

export const modalRegistry = new ModalRegistry();
